import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

const PaymentCancel = () => {
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6 py-24">
      <div className="max-w-lg w-full text-center bg-[#141210] border border-[#2c2822] rounded-2xl px-8 py-14">
        <XCircle size={58} className="text-[#a29a8c] mx-auto mb-6" strokeWidth={1.4} />
        <h1 className="font-display text-4xl text-[#f4efe4] mb-4">Checkout cancelled</h1>
        <p className="text-[#a29a8c] mb-8">
          No payment was taken. Your cart is still saved — you can pick up right where you left off.
        </p>
        <Link to="/shop" className="btn-gold inline-flex px-9 py-3 rounded-full text-sm tracking-[0.15em] uppercase">
          Return to Shop
        </Link>
      </div>
    </div>
  );
};

export default PaymentCancel;
